import { render, staticRenderFns } from "./ProgramLogo.vue?vue&type=template&id=77d842fd&scoped=true"
import script from "./ProgramLogo.vue?vue&type=script&lang=js"
export * from "./ProgramLogo.vue?vue&type=script&lang=js"
import style0 from "./ProgramLogo.vue?vue&type=style&index=0&id=77d842fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d842fd",
  null
  
)

export default component.exports